(function () {
  'use strict';

  function initPartnership(root) {
    if (!root || root.dataset.partnershipReady === 'true') return;
    root.dataset.partnershipReady = 'true';

    var success = root.querySelector('[data-partnership-success]');
    if (success) {
      success.focus({ preventScroll: true });
      return;
    }

    var form = root.querySelector('form');
    if (!form) return;

    var marketField = form.querySelector('[data-market-field]');
    var marketTrigger = form.querySelector('[data-market-trigger]');
    var marketTriggerLabel = form.querySelector('[data-market-trigger-label]');
    var marketValue = form.querySelector('[data-market-value]');
    var marketChips = form.querySelector('[data-market-chips]');
    var marketCombobox = form.querySelector('[data-market-combobox]');
    var marketMenu = form.querySelector('[data-market-menu]');
    var marketError = form.querySelector('[data-market-error]');
    var partnerGroup = form.querySelector('[data-partner-group]');
    var partnerOptions = Array.prototype.slice.call(form.querySelectorAll('[data-partner-option]'));
    var partnerValue = form.querySelector('[data-partner-value]');
    var otherToggle = form.querySelector('[data-partner-other]');
    var otherField = form.querySelector('[data-partner-other-field]');
    var otherInput = form.querySelector('[data-partner-other-input]');
    var website = form.querySelector('[data-website]');
    var phoneField = form.querySelector('[data-phone-field]');
    var countryPicker = form.querySelector('[data-country-picker]');
    var countryTrigger = form.querySelector('[data-country-trigger]');
    var countryTriggerFlag = form.querySelector('[data-country-trigger-flag]');
    var countryTriggerCode = form.querySelector('[data-country-trigger-code]');
    var countryMenu = form.querySelector('[data-country-menu]');
    var phoneCountry = form.querySelector('[data-phone-country]');
    var phoneNumber = form.querySelector('[data-phone-number]');
    var phone = form.querySelector('[data-phone]');
    var clientErrors = form.querySelector('[data-client-errors]');
    var submitButton = form.querySelector('[data-submit-button]');
    var submitLabel = form.querySelector('[data-submit-label]');
    var markets = [];
    var countryOptions = [];
    var countryItems = [];
    var countryTypeahead = '';
    var countryTypeaheadTimer;
    var marketItems = [];
    var visibleMarketItems = [];

    if (phoneCountry) {
      Array.prototype.forEach.call(phoneCountry.querySelectorAll('option[data-country-name]'), function (option) {
        countryOptions.push(option);
      });
    }

    if (marketValue) {
      marketValue.name = 'contact[Which market(s) are you interested in?]';
      marketValue.disabled = false;
    }

    function normalizeWebsite() {
      if (!website) return;
      var value = website.value.trim();
      if (value && !/^[a-z][a-z0-9+.-]*:\/\//i.test(value)) {
        website.value = 'https://' + value;
      }
    }

    function getCountryFlag(option) {
      if (!option) return '🌐';
      var countryName = option.dataset.countryName || '';
      return option.textContent.trim().slice(0, option.textContent.trim().indexOf(countryName)).trim() || '🌐';
    }

    function getCountryCode(option) {
      var regionalIndicators = Array.from(getCountryFlag(option));
      if (regionalIndicators.length !== 2) return '';

      return regionalIndicators.map(function (indicator) {
        return String.fromCharCode(indicator.codePointAt(0) - 127397);
      }).join('').toLowerCase();
    }

    function renderCountryFlag(container, option, lazy) {
      if (!container) return;
      var countryCode = getCountryCode(option);
      container.textContent = '';

      if (!countryCode) {
        container.textContent = '🌐';
        return;
      }

      var image = document.createElement('img');
      image.src = 'https://flagcdn.io/flags/4x3/' + countryCode + '.svg';
      image.alt = '';
      image.width = 24;
      image.height = 18;
      image.decoding = 'async';
      if (lazy) image.loading = 'lazy';
      image.addEventListener('error', function () {
        container.textContent = '🌐';
      });
      container.appendChild(image);
    }

    function updateCountryPicker() {
      if (!phoneCountry || !countryTrigger) return;
      var selectedOption = phoneCountry.options[phoneCountry.selectedIndex];
      var hasCountry = Boolean(selectedOption && selectedOption.dataset.countryName);

      if (countryTriggerFlag) renderCountryFlag(countryTriggerFlag, hasCountry ? selectedOption : null, false);
      if (countryTriggerCode) countryTriggerCode.textContent = hasCountry ? selectedOption.dataset.dialCode : 'Code';
      countryTrigger.setAttribute(
        'aria-label',
        hasCountry
          ? selectedOption.dataset.countryName + ' ' + selectedOption.dataset.dialCode + '. Change country calling code.'
          : 'Choose country calling code'
      );

      countryItems.forEach(function (item, index) {
        var isSelected = hasCountry && countryOptions[index] === selectedOption;
        item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
    }

    function closeCountryMenu(returnFocus) {
      if (!countryMenu || !countryTrigger || countryMenu.hidden) return;
      countryMenu.hidden = true;
      countryTrigger.setAttribute('aria-expanded', 'false');
      countryPicker.classList.remove('is-open');
      if (returnFocus) countryTrigger.focus();
    }

    function focusCountryItem(index) {
      if (!countryItems.length) return;
      var safeIndex = (index + countryItems.length) % countryItems.length;
      countryItems[safeIndex].focus();
      countryItems[safeIndex].scrollIntoView({ block: 'nearest' });
    }

    function openCountryMenu(focusLast) {
      if (!countryMenu || !countryTrigger) return;
      countryMenu.hidden = false;
      countryTrigger.setAttribute('aria-expanded', 'true');
      countryPicker.classList.add('is-open');

      var selectedOption = phoneCountry.options[phoneCountry.selectedIndex];
      var selectedIndex = countryOptions.indexOf(selectedOption);
      if (selectedIndex < 0) selectedIndex = focusLast ? countryItems.length - 1 : 0;
      focusCountryItem(selectedIndex);
    }

    function selectCountry(index, returnFocus) {
      var option = countryOptions[index];
      if (!option) return;
      phoneCountry.value = option.value;
      updateCountryPicker();
      phoneCountry.dispatchEvent(new Event('change', { bubbles: true }));
      closeCountryMenu(returnFocus);
    }

    function initCountryPicker() {
      if (!countryPicker || !countryTrigger || !countryMenu || !phoneCountry || !countryOptions.length) return;

      if (!phoneCountry.value) {
        var defaultCountry = (root.dataset.defaultCountry || '').toLowerCase();
        var defaultOption = countryOptions.filter(function (option) {
          return option.dataset.countryName.toLowerCase() === defaultCountry;
        })[0];
        if (!defaultOption) {
          defaultOption = countryOptions.filter(function (option) {
            return option.dataset.countryName === 'Lebanon';
          })[0];
        }
        if (defaultOption) phoneCountry.value = defaultOption.value;
      }

      countryOptions.forEach(function (option, index) {
        var item = document.createElement('button');
        var flag = document.createElement('span');
        var name = document.createElement('span');
        var code = document.createElement('span');

        item.type = 'button';
        item.className = 'partnership-country-option';
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', 'false');
        item.tabIndex = -1;
        flag.className = 'partnership-country-flag';
        flag.setAttribute('aria-hidden', 'true');
        renderCountryFlag(flag, option, true);
        name.className = 'partnership-country-name';
        name.textContent = option.dataset.countryName;
        code.className = 'partnership-country-option__code';
        code.textContent = option.dataset.dialCode;

        item.appendChild(flag);
        item.appendChild(name);
        item.appendChild(code);
        item.addEventListener('click', function () { selectCountry(index, true); });
        countryMenu.appendChild(item);
        countryItems.push(item);
      });

      countryPicker.classList.add('is-ready');
      updateCountryPicker();

      countryTrigger.addEventListener('click', function () {
        if (countryMenu.hidden) openCountryMenu(false);
        else closeCountryMenu(true);
      });

      countryTrigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          openCountryMenu(event.key === 'ArrowUp');
        }
      });

      countryMenu.addEventListener('keydown', function (event) {
        var currentIndex = countryItems.indexOf(document.activeElement);

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          focusCountryItem(currentIndex + (event.key === 'ArrowDown' ? 1 : -1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          focusCountryItem(event.key === 'Home' ? 0 : countryItems.length - 1);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          closeCountryMenu(true);
        } else if (event.key === 'Tab') {
          closeCountryMenu(false);
        } else if (event.key.length === 1 && !event.altKey && !event.ctrlKey && !event.metaKey) {
          countryTypeahead += event.key.toLowerCase();
          window.clearTimeout(countryTypeaheadTimer);
          countryTypeaheadTimer = window.setTimeout(function () { countryTypeahead = ''; }, 650);

          var matchIndex = countryOptions.findIndex(function (option) {
            return option.dataset.countryName.toLowerCase().indexOf(countryTypeahead) === 0;
          });
          if (matchIndex >= 0) focusCountryItem(matchIndex);
        }
      });

      document.addEventListener('pointerdown', function handleCountryOutsideClick(event) {
        if (!root.isConnected) {
          document.removeEventListener('pointerdown', handleCountryOutsideClick);
          return;
        }
        if (!countryMenu.hidden && !countryPicker.contains(event.target)) closeCountryMenu(false);
      });
    }

    function validatePhone() {
      if (!phoneCountry || !phoneNumber || !phone) return true;
      var selectedOption = phoneCountry.options[phoneCountry.selectedIndex];
      var dialCode = selectedOption ? selectedOption.dataset.dialCode || '' : '';
      var localNumber = phoneNumber.value.trim();
      var combinedNumber = dialCode && localNumber ? dialCode + ' ' + localNumber : '';
      var digitCount = combinedNumber.replace(/\D/g, '').length;
      var validCharacters = /^[0-9\s().-]+$/.test(localNumber);
      var valid = Boolean(dialCode && localNumber && validCharacters && digitCount >= 7 && digitCount <= 15);

      phone.value = combinedNumber;
      phoneNumber.setCustomValidity(valid ? '' : 'Select a country code and enter a valid phone number.');
      if (countryTrigger) {
        countryTrigger.classList.toggle('is-invalid', !dialCode && phoneField.dataset.touched === 'true');
        countryTrigger.setAttribute('aria-invalid', dialCode ? 'false' : 'true');
      }
      phoneField.classList.toggle('is-invalid', !valid && phoneField.dataset.touched === 'true');
      phoneField.setAttribute('aria-invalid', valid ? 'false' : 'true');
      return valid;
    }

    function syncPartnerTypes() {
      var selected = partnerOptions.filter(function (option) {
        return option.checked;
      }).map(function (option) {
        return option.closest('label').lastElementChild.textContent.trim();
      });

      if (otherToggle && otherField && otherInput) {
        otherField.hidden = !otherToggle.checked;
        otherInput.disabled = !otherToggle.checked;
        otherInput.required = otherToggle.checked;
        if (!otherToggle.checked) {
          otherInput.value = '';
          clearInvalid(otherInput);
        }
      }

      if (partnerValue) {
        partnerValue.value = selected.map(function (partnerType) {
          if (partnerType === 'Other' && otherInput && otherInput.value.trim()) {
            return 'Other: ' + otherInput.value.trim();
          }
          return partnerType;
        }).join(', ');
      }

      if (partnerOptions[0]) {
        partnerOptions[0].setCustomValidity(selected.length ? '' : 'Select at least one partner type.');
      }
      partnerGroup.classList.toggle('is-invalid', selected.length === 0 && partnerGroup.dataset.touched === 'true');
      partnerGroup.setAttribute('aria-invalid', selected.length ? 'false' : 'true');
      return selected.length > 0;
    }

    function syncMarkets() {
      var valid = markets.length > 0;

      if (marketValue) marketValue.value = markets.join(', ');
      if (marketTrigger) {
        marketTrigger.setAttribute('aria-invalid', valid ? 'false' : 'true');
      }
      if (marketTriggerLabel) marketTriggerLabel.textContent = valid ? 'Select another country' : 'Select country';
      if (marketError) marketError.textContent = 'Select at least one country.';
      marketField.classList.toggle('is-invalid', !valid && marketField.dataset.touched === 'true');
      marketField.setAttribute('aria-invalid', valid ? 'false' : 'true');
    }

    function filterMarketMenu() {
      if (!marketMenu) return 0;

      visibleMarketItems = marketItems.filter(function (item) {
        var countryName = item.dataset.countryName;
        var isSelected = markets.some(function (market) {
          return market.toLowerCase() === countryName.toLowerCase();
        });
        item.hidden = isSelected;
        return !item.hidden;
      });
      return visibleMarketItems.length;
    }

    function closeMarketMenu(returnFocus) {
      if (!marketMenu || !marketTrigger) return;
      marketMenu.hidden = true;
      marketTrigger.setAttribute('aria-expanded', 'false');
      if (marketCombobox) marketCombobox.classList.remove('is-open');
      if (returnFocus) marketTrigger.focus({ preventScroll: true });
    }

    function focusMarketItem(index) {
      if (!visibleMarketItems.length) return;
      var safeIndex = (index + visibleMarketItems.length) % visibleMarketItems.length;
      visibleMarketItems[safeIndex].focus();
      visibleMarketItems[safeIndex].scrollIntoView({ block: 'nearest' });
    }

    function openMarketMenu(focusIndex) {
      if (!marketMenu || !marketTrigger) return;
      if (!filterMarketMenu()) {
        closeMarketMenu(false);
        return;
      }
      marketMenu.hidden = false;
      marketTrigger.setAttribute('aria-expanded', 'true');
      if (marketCombobox) marketCombobox.classList.add('is-open');
      if (typeof focusIndex === 'number') focusMarketItem(focusIndex);
    }

    function toggleMarketMenu() {
      if (!marketMenu) return;
      if (marketMenu.hidden) openMarketMenu();
      else closeMarketMenu(false);
    }

    function selectMarketItem(item, returnFocus) {
      if (!item) return;
      var country = item.dataset.countryName;
      var duplicate = markets.some(function (market) {
        return market.toLowerCase() === country.toLowerCase();
      });

      if (!duplicate) markets.push(country);
      marketField.dataset.touched = 'true';
      renderMarkets();
      closeMarketMenu(returnFocus);
    }

    function initMarketPicker() {
      if (!marketCombobox || !marketMenu || !marketTrigger || !countryOptions.length) return;

      countryOptions.forEach(function (option, index) {
        var item = document.createElement('button');
        item.type = 'button';
        item.id = marketMenu.id + '-Option-' + index;
        item.className = 'partnership-market-option';
        item.dataset.countryName = option.dataset.countryName;
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', 'false');
        item.tabIndex = -1;
        item.textContent = option.dataset.countryName;
        item.addEventListener('click', function (event) {
          selectMarketItem(item, event.detail === 0);
        });
        marketMenu.appendChild(item);
        marketItems.push(item);
      });

      marketCombobox.classList.add('is-ready');

      marketTrigger.addEventListener('click', toggleMarketMenu);

      marketTrigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          openMarketMenu(event.key === 'ArrowDown' ? 0 : visibleMarketItems.length - 1);
        }
      });

      marketMenu.addEventListener('keydown', function (event) {
        var currentIndex = visibleMarketItems.indexOf(document.activeElement);

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          focusMarketItem(currentIndex + (event.key === 'ArrowDown' ? 1 : -1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          focusMarketItem(event.key === 'Home' ? 0 : visibleMarketItems.length - 1);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          closeMarketMenu(true);
        } else if (event.key === 'Tab') {
          closeMarketMenu(false);
        }
      });

      marketCombobox.addEventListener('focusout', function (event) {
        if (event.relatedTarget && !marketCombobox.contains(event.relatedTarget)) {
          closeMarketMenu(false);
        }
      });

      document.addEventListener('pointerdown', function handleMarketOutsideClick(event) {
        if (!root.isConnected) {
          document.removeEventListener('pointerdown', handleMarketOutsideClick);
          return;
        }
        if (!marketMenu.hidden && !marketCombobox.contains(event.target)) closeMarketMenu(false);
      });
    }

    function renderMarkets() {
      if (!marketChips) return;
      marketChips.innerHTML = '';
      markets.forEach(function (market, index) {
        var chip = document.createElement('span');
        var text = document.createElement('span');
        var remove = document.createElement('button');

        chip.className = 'partnership-market-chip';
        text.textContent = market;
        remove.type = 'button';
        remove.setAttribute('aria-label', 'Remove ' + market);
        remove.textContent = '×';
        remove.addEventListener('click', function () {
          markets.splice(index, 1);
          marketField.dataset.touched = 'true';
          renderMarkets();
          marketTrigger.focus();
        });

        chip.appendChild(text);
        chip.appendChild(remove);
        marketChips.appendChild(chip);
      });
      syncMarkets();
      filterMarketMenu();
    }

    function clearInvalid(field) {
      if (!field) return;
      field.classList.remove('is-invalid');
      field.removeAttribute('aria-invalid');
      if (field !== phone) field.setCustomValidity('');
    }

    if (website) {
      website.addEventListener('blur', normalizeWebsite);
      website.addEventListener('input', function () { clearInvalid(website); });
    }

    initCountryPicker();

    if (phoneCountry) {
      phoneCountry.addEventListener('change', function () {
        phoneCountry.classList.remove('is-invalid');
        updateCountryPicker();
        validatePhone();
      });
    }

    if (phoneNumber) {
      phoneNumber.addEventListener('blur', function () {
        phoneField.dataset.touched = 'true';
        validatePhone();
      });
      phoneNumber.addEventListener('input', function () {
        phoneNumber.setCustomValidity('');
        phoneNumber.classList.remove('is-invalid');
        phoneField.classList.remove('is-invalid');
        validatePhone();
      });
    }

    partnerOptions.forEach(function (option) {
      option.addEventListener('change', function () {
        partnerGroup.dataset.touched = 'true';
        syncPartnerTypes();
      });
    });
    if (otherInput) otherInput.addEventListener('input', syncPartnerTypes);
    syncPartnerTypes();

    initMarketPicker();
    syncMarkets();

    Array.prototype.slice.call(form.querySelectorAll('input[required], select[required]')).forEach(function (field) {
      field.addEventListener('input', function () {
        if (field.validity.valid) clearInvalid(field);
      });
    });

    form.addEventListener('submit', function (event) {
      normalizeWebsite();

      partnerGroup.dataset.touched = 'true';
      marketField.dataset.touched = 'true';
      phoneField.dataset.touched = 'true';
      var partnerValid = syncPartnerTypes();
      syncMarkets();
      var phoneValid = validatePhone();

      var requiredFields = Array.prototype.slice.call(form.querySelectorAll('input[required], select[required]'));
      requiredFields.forEach(function (field) {
        var invalid = !field.checkValidity();
        field.classList.toggle('is-invalid', invalid);
        field.setAttribute('aria-invalid', invalid ? 'true' : 'false');
      });

      var valid = form.checkValidity() && partnerValid && markets.length > 0 && phoneValid;
      if (!valid) {
        event.preventDefault();
        clientErrors.hidden = false;
        clientErrors.focus({ preventScroll: true });

        var firstInvalid = form.querySelector('.is-invalid input, .is-invalid select, .is-invalid button, input.is-invalid, select.is-invalid, button.is-invalid, [aria-invalid="true"] input, [aria-invalid="true"] select, [aria-invalid="true"] button');
        if (firstInvalid) {
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          window.setTimeout(function () { firstInvalid.focus(); }, 250);
        }
        return;
      }

      clientErrors.hidden = true;
      if (submitButton) submitButton.disabled = true;
      if (submitLabel) submitLabel.textContent = 'Submitting…';
    });

    var serverErrors = form.querySelector('[data-server-errors]');
    if (serverErrors) serverErrors.focus({ preventScroll: true });
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-partnership-root]')) initPartnership(context);
    Array.prototype.forEach.call(context.querySelectorAll('[data-partnership-root]'), initPartnership);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
